const isValidDateRange = (start_date, end_date) => {
    if (!start_date || !end_date) return true;
    return new Date(start_date) <= new Date(end_date);
}

export default isValidDateRange;
